import { render } from "./EventRequestTable.vue?vue&type=template&id=33df2c28&scoped=true"
import script from "./EventRequestTable.vue?vue&type=script&lang=js"
export * from "./EventRequestTable.vue?vue&type=script&lang=js"

import "./EventRequestTable.vue?vue&type=style&index=0&id=33df2c28&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33df2c28"]])

export default __exports__